"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AltContainerStyled = exports.ExpanderItemHeaderStyled = exports.ExpanderItemStyled = exports.ExpanderUiStyled = exports.ExpanderAEMStyled = exports.StyledBox = void 0;

var _uiKit = require("@dbi-tools/ui-kit");

var _helpers = require("../../helpers");

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n      background-color: ", ";\n\n      ", " {\n        padding-left: 25px;\n        padding-right: 25px;\n        margin: 0 -9px;\n      }\n\n      ", " {\n        padding-left: 15px;\n        padding-right: 15px;\n        margin: 0;\n      }\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n\n  ", " {\n    margin: 0 -9px;\n  }\n\n  ", " {\n    margin: 0;\n  }\n\n  ", "\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-bottom: 15px;\n\n  &:hover {\n    cursor: pointer;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      & * {\n        color: ", ";\n      }\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  border-bottom: 1px solid ", ";\n  padding: 30px 0 15px;\n\n  ", ";\n\n  .ReactCollapse--collapse {\n    transition: height 500ms;\n  }\n\n  img {\n    max-width: 100%;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  ", ";\n\n  &:before {\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    left: 0;\n    top: 0;\n    z-index: -1;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledBox = (0, _uiKit.styled)(_uiKit.Box)(_templateObject(), function (_ref) {
  var $theme = _ref.theme.$theme;
  return $theme && (0, _helpers.getTheme)($theme);
});
exports.StyledBox = StyledBox;
var ExpanderAEMStyled = (0, _uiKit.styled)('div')(_templateObject2());
exports.ExpanderAEMStyled = ExpanderAEMStyled;
var ExpanderUiStyled = (0, _uiKit.styled)('div')(_templateObject3());
exports.ExpanderUiStyled = ExpanderUiStyled;
var ExpanderItemStyled = (0, _uiKit.styled)('div')(_templateObject4(), function (_ref2) {
  var isDarkTheme = _ref2.isDarkTheme;
  return isDarkTheme ? _uiKit.Colors.white : _uiKit.Colors.gray300;
}, function (_ref3) {
  var isDarkTheme = _ref3.isDarkTheme;
  return isDarkTheme && (0, _uiKit.css)(_templateObject5(), _uiKit.Colors.white);
});
exports.ExpanderItemStyled = ExpanderItemStyled;
var ExpanderItemHeaderStyled = (0, _uiKit.styled)('header')(_templateObject6());
exports.ExpanderItemHeaderStyled = ExpanderItemHeaderStyled;
var AltContainerStyled = (0, _uiKit.styled)(_uiKit.Box)(_templateObject7(), _uiKit.Colors.transparent, _uiKit.GridBreakpointsMediaDown.lg, _uiKit.GridBreakpointsMediaDown.md, function (_ref4) {
  var isAltTheme = _ref4.isAltTheme;
  return isAltTheme && (0, _uiKit.css)(_templateObject8(), _uiKit.Colors.white, _uiKit.GridBreakpointsMediaDown.lg, _uiKit.GridBreakpointsMediaDown.md);
});
exports.AltContainerStyled = AltContainerStyled;